import { Tooltip, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'

import { getTranslate, lang } from '../../localization'
import { AddOn } from '../../types/rateplan'
import InventoryInputItem from './InventoryInputItem'
import useStyles from './styles/AddonForBulkUpdate.style'

interface AddonsForBulkUpdateProps {
  providerAddOns: AddOn[]
  setProviderAddOns: React.Dispatch<React.SetStateAction<AddOn[]>>
  providerName: string
}
export default function AddonsForBulkUpdate({
  providerAddOns,
  setProviderAddOns,
  providerName
}: AddonsForBulkUpdateProps) {
  const classes = useStyles()
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div className={classes.root}>
      <div className={classes.restrictionSelector}>
        <div className={classes.titleRestrictions}>
          <Typography className={classes.ratePlaneTextAddons}>
            {providerName}
          </Typography>
        </div>
        <div
          className={[
            classes.valueContainer,
            classes.restrictionSelectorTitle
          ].join(' ')}>
          <Typography>
            {isSmall ? getTranslate('') : getTranslate('Rate') + ' :'}
          </Typography>
        </div>
      </div>
      {providerAddOns.map((item, index) => (
        <InventoryInputItem
          key={index}
          label={lang === 'en' ? item.name : item.nameTranslatedList[0].value}
          value={item.amount ? item.amount?.toString() : ''}
          onChange={(value) =>
            setProviderAddOns([
              ...providerAddOns.slice(0, index),
              {
                ...providerAddOns[index],
                amount: parseInt(value, 10)
              },
              ...providerAddOns.slice(index + 1)
            ])
          }
          showCurrencySelector
          onChangeCurrency={(value) =>
            setProviderAddOns([
              ...providerAddOns.slice(0, index),
              {
                ...providerAddOns[index],
                currency: value
              },
              ...providerAddOns.slice(index + 1)
            ])
          }
          icon={
            <Tooltip
              title={
                <div>
                  <Typography className={classes.tooltipTitle}>
                    {getTranslate('Multiplier : ')}
                    {getTranslate(`${item.applyMultiplier}`)}
                    <br />
                    {getTranslate('Per Person : ')}
                    {getTranslate(`${item.perPerson}`)}
                    <br />
                    {getTranslate('Per Night : ')}
                    {getTranslate(`${item.perRoomNight}`)}
                  </Typography>
                </div>
              }
              placement="top"
              classes={{
                popper: classes.tooltip,
                tooltip: classes.tooltip
              }}>
              <InfoIcon className={classes.infoIcon} />
            </Tooltip>
          }
        />
      ))}
    </div>
  )
}
